export const QueryKeys = {
  REGISTER: "register",
  USER: "user",
  DELETE_USER: "delete-user",
  USER_STATS: "user-stats",
  BODY_STATS: "body-stats",
  ACTIVITY_LEVEL: "activity-level",
  MEDICAL: "medical",
  FITNESS_PROFILE: "fitness-profile",
  ALLERGY_OPTIONS: "allergy-options",
  SUPERMARKET_OPTIONS: "supermarket-options",
  SUPERMARKET_PREFERENCES: "supermarket-preferences",
  LIFESTYLE: "lifestyle",
  LIFESTYLE_OPTIONS: "lifestyle-options",
  GOALS: "goals",
  NUTRITIONAL_REQUIREMENT: "nutritional-requirement",
  FOOD_AVOIDS: "food-avoids",
  FOOD_AVOID_OPTIONS: "food-avoid-options",
  DIETARY_REQUIREMENT: "dietary-requirement",
  DIETARY_REQUIREMENT_OPTIONS: "dietary-requirement-options",
  MEAL_PREFERENCES: "meal-preferences",
  MEAL_PREFERENCE_SUGGESTIONS: "meal-preference-suggestions",
  MEAL_TYPE_PREFERENCE_LIFESTYLE: "meal-type-preference-lifestyle",
  FAVORITE_CUISINES: "favorite-cuisines",
  FAVORITE_MEALS: "favorite-meals",
  DISLIKED_MEALS: "disliked-meals",
  GENERATION_STATUS: "generation-status",
  ALL_GENERATION_STATUS: "all-generation-status",
  PLAN: "plan",
  PLAN_STREAKS: "plan-streaks",
  BALANCE_CALORIES: "balance-calories",
  BALANCE_PROTEIN: "balance-protein",
  PLAN_RECALIBRATE: "plan-recalibrate",
  DASHBOARD_MESSAGES: "dashboard-messages",
  PLAN_MEAL: "plan-meal",
  PLAN_MEAL_SWAP_CONFIRM: "plan-meal-swap-confirm",
  PLAN_MEAL_SWAP_UNDO: "plan-meal-swap-undo",
  PLAN_DETAIL_MEAL: "plan-detail-meal",
  PLAN_MEAL_TICK: "plan-meal-tick",
  PLAN_MEAL_SKIP: "plan-meal-skip",
  PLAN_ALTERNATIVE_FILTER_OPTIONS: "plan-alternative-filter-options",
  PLAN_ALTERNATIVE: "plan-alternative",
  PLAN_ALTERNATIVE_SEARCH_TAGS: "plan-alternative-search-tags",
  PLAN_EXTRA_FOOD: "plan-extra-food",
  PLAN_ADD_MEAL_SLOT: "plan-add-meal-slot",
  PLAN_REMOVE_MEAL_FROM_SLOT: "plan-remove-meal-from-slot",
  PLAN_REPEAT_MEAL: "plan-repeat-meal",
  CALORIE_BUDGET: "calorie-budget",
  CARB_OPTIONS: "carb-options",
  MILK_OPTIONS: "milk-options",
  GO_TO_SELECT_MEAL: "goto-select-meal",
  GO_TO_CANDIDATE: "goto-candidate",
  GO_TO_GENERATION_STATUS: "goto-generation-status",
  GO_TO_ALL_GENERATION_STATUS: "goto-all-generation-status",
  GO_TO_PREFERENCE: "goto-preference",
  FEEDBACK: "feedback",
  MEAL_FEEDBACK: "meal-feedback",
  SHOPPING_LIST: "shopping-list",
  SUBSCRIPTION_OFFERINGS: "subscription-offerings",
  SUBSCRIPTION_CUSTOMER_INFO: "subscription-customer-info",
  SUBSCRIPTION_STATUS: "subscription-status",
  SUBSCRIPTION_VERIFY: "subscription-verify",
  SUBSCRIPTION_ACCESS_STATUS: "subscription-access-status",
  YOUR_FOOD: "your-food",
  MY_FOODS: "my-foods",
  MY_FOODS_REMOVE: "my-foods-remove",
  MY_FOODS_FAVOURITES_REMOVE: "my-foods-favourites-remove",
  YOUR_FOOD_STATUS: "your-food-status",
  FRUIT_PICKS: "fruit-picks",
  POPULAR_MEALS: "popular-meals",
  HIGH_PROTEIN_MEALS: "high-protein-meals",
  TOP_PICKS: "top-picks",
  VEG_SIDES: "veg-sides",
  SCALED_SERVINGS: "scaled-servings",
  OTHER_PREFERENCES: "other-preferences",
} as const;
